import { Box, Typography } from '@mui/material';
import React from 'react';

const FieldLabel = ({ label, value, dataTestId }) => (
  <Box>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      {label}
    </Typography>
    <Typography variant="body1" data-testid={dataTestId}>
      {value ?? 'N/A'}
    </Typography>
  </Box>
);

export default React.memo(FieldLabel);
